import { h } from 'preact'
//import { useState, useEffect, useRef } from 'preact/hooks

function Stack({
    row,
    column,
    justify,
    padding,
    align,
    gap,
    order,
    fullWidth,
    as,
    wrap,
    direction,
    background,
    className,
    children,
}) {
    const paddingString = (p) => p
    const paddingNumber = (p) => p !== 0 ? `var(--unit-${p})` : '0';

    const paddingStyles = typeof (padding) == 'string' ? paddingString(padding) : paddingNumber(padding);

    const element = as ? document.createElement(as) : null;
    
    return (
        <div
            className={className}
            style={{
                order: order || 'initial',
                background: background || 'transparent',
                display: 'flex',
                alignItems: align || 'center',
                justifyContent: justify || 'center',
                flexDirection: column ? 'column' : direction || 'row',
                gap: gap ? `var(--unit-${gap})` : 'var(--unit-2)',
                padding: paddingStyles,
                flexWrap: wrap ? 'wrap' : 'nowrap',
                width: fullWidth ? '100%' : 'initial',
            }}>
            {children}
        </div>
    )
}

export default Stack
